module.exports = __webpack_public_path__ + "media/images/icon/icons8-In Progress-b1919c7aec80f6e8c06bb16f8f1557a6.png";